import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;
Vue.use(Argon);

// Make BootstrapVue available throughout your project
 Vue.use(BootstrapVue)

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
